module.exports = __webpack_public_path__ + "static/media/riti.f07c958b.png";